import { DynamicSectionProvider } from "./contexts/dynamicSectionContext";
import { TemplateDataProvider } from "./contexts/templateDataContext";
import { ValidationProvider } from "./contexts/validation";
import { ContainerProps } from "./types";

export default function DynamicEditorContainer(props: ContainerProps) {
	const { validationResults, templateData, ...rest } = props;
	const { validateOnSave, validateComponentIf, alwaysShowPages } = rest;
	const { sections } = rest;
	const vProps = { validationResults, validateOnSave, validateComponentIf };

	return (
		<TemplateDataProvider templateData={templateData}>
			<ValidationProvider {...vProps}>
				<DynamicSectionProvider sections={sections} alwaysShowPages={alwaysShowPages}>
					{props.children}
				</DynamicSectionProvider>
			</ValidationProvider>
		</TemplateDataProvider>
	);
}
